export default {"src":"/_next/static/media/dotsLight.0a05889b.svg","height":763,"width":184,"blurWidth":0,"blurHeight":0};